module.exports = __webpack_public_path__ + "static/donut-404-870fece66a24137d5767997c66bed9fa.mp4";